module.exports = __webpack_public_path__ + "img/valley.cfb568c9.png";